import baseCotton from "./baseCotton_cotton/img_baseCotton_cotton.jpg";
import baseCottonP from "./baseCotton_cotton/img_baseCotton_cotton_p.jpg";

import baseCottonBunny from "./baseCotton_cotton/img_baseCottonBunny_cotton.jpg";
import baseCottonBunnyP from "./baseCotton_cotton/img_baseCottonBunny_cotton_p.jpg";

import baseCottonEars from "./baseCotton_cotton/img_baseCottonEars_cotton.jpg";
import baseCottonEarsP from "./baseCotton_cotton/img_baseCottonEars_cotton_p.jpg";

import baseCottonBunnyEars from "./baseCotton_cotton/img_baseCottonBunnyEars_cotton.jpg";
import baseCottonBunnyEarsP from "./baseCotton_cotton/img_baseCottonBunnyEars_cotton_p.jpg";


export default [
    {
        type: "baseCotton",
        noPostcard: baseCotton,
        withPostcard: baseCottonP,
    },
    {
        type: "baseCottonBunny",
        noPostcard: baseCottonBunny,
        withPostcard: baseCottonBunnyP,
    },
    {
        type: "baseCottonEars",
        noPostcard: baseCottonEars,
        withPostcard: baseCottonEarsP,
    },
    {
        type: "baseCottonBunnyEars",
        noPostcard: baseCottonBunnyEars,
        withPostcard: baseCottonBunnyEarsP,
    }
]